import { render, staticRenderFns } from "./ProductCenter.vue?vue&type=template&id=62168528&scoped=true&"
import script from "./ProductCenter.vue?vue&type=script&lang=js&"
export * from "./ProductCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62168528",
  null
  
)

export default component.exports